window.addEventListener('DOMContentLoaded', () => {

    const isFinnish = document.querySelector('html').lang === 'fi';

    const container = document.createElement('div');
    container.className = 'chooser-popup';

    const popupOpener = document.createElement('a');

    const icon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.6 15.675L9.1 13.05C9.14375 13.0187 9.19687 13 9.25 13H13C14.6562 13 16 11.6562 16 10V3C16 1.34375 14.6562 0 13 0H3C1.34375 0 0 1.34375 0 3V10C0 11.6562 1.34375 13 3 13H4V15.125C4 15.6094 4.39062 16 4.875 16C5.06563 16 5.25 15.9375 5.4 15.825L5.6 15.675ZM5 13V12.75C5 12.3344 4.66563 12 4.25 12H3C1.89688 12 1 11.1031 1 10V3C1 1.89688 1.89688 1 3 1H13C14.1031 1 15 1.89688 15 3V10C15 11.1031 14.1031 12 13 12H9.25C8.97812 12 8.71562 12.0875 8.5 12.25L5 14.875V13ZM4.5 5C4.225 5 4 5.225 4 5.5C4 5.775 4.225 6 4.5 6H11.5C11.775 6 12 5.775 12 5.5C12 5.225 11.775 5 11.5 5H4.5ZM4.5 8C4.225 8 4 8.225 4 8.5C4 8.775 4.225 9 4.5 9H8.5C8.775 9 9 8.775 9 8.5C9 8.225 8.775 8 8.5 8H4.5Z" fill="#1A2E40"/>
        </svg>
        `

    let gameID = 'kTokYAJJ6FMN6sfhSKUY';
    popupOpener.textContent = 'Hei, tarvitsetko apua?';

    if (!isFinnish) {
        gameID = 'rKDbddQCJApiiSpp2syM';
        popupOpener.textContent = 'Hi, do you need help?';
    }

    popupOpener.href = "#jquest-popup-" + gameID

    const jquestApp = document.createElement('a');

    jquestApp.className = 'jquest-app';
    jquestApp.setAttribute('data-new-styles', 'true');
    jquestApp.setAttribute('data-locale', 'fi');
    jquestApp.setAttribute('data-org-id', '7QAI2kaGzRB0YOZPtK5J');
    jquestApp.setAttribute('data-game-id', gameID);
    jquestApp.setAttribute('data-popup', 'true');
    jquestApp.setAttribute('data-popup-auto', 'false');
    jquestApp.setAttribute('data-popup-attach', '.chooser-popup');
    jquestApp.setAttribute('data-popup-disable-dismiss', 'true');

    popupOpener.appendChild(jquestApp);

    const iconContainer = document.createElement('div');
    iconContainer.className = 'icon-container';
    iconContainer.insertAdjacentHTML('beforeend', icon);

    popupOpener.appendChild(iconContainer);

    container.appendChild(popupOpener);
    document.body.appendChild(container);

    const script = document.createElement('script');
    script.src = "https://files.jquest.fi/jquest/latest/jquest-latest.js";
    script.type = 'module';
    script.setAttribute('data-cookieconsent-ignore', 'true');

    document.head.appendChild(script);

});
